const getLowerStrength = (inputStrength) => {
    switch (inputStrength) {
        case 'alpha':
            return 'beta';
        case 'beta':
            return 'gamma';
        case 'gamma':
            return 'delta';
        default:
            // delta
            return 'epsilon';
    }
};
export default getLowerStrength;
//# sourceMappingURL=getLowerStrength.js.map